/* External */
import { memo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Providers */
import { useGtmLocalContext } from '../../providers/GtmLocalProvider';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import useClickCallback from '../../hooks/useClickCallback';

function Season({
  className,
  focused,
  isSelected,
  seasonNumber,
  onSelect,
  onMouseEnter,
}) {
  const { gtmChangeItem } = useGtmLocalContext();
  const { formatMessage } = useIntl();
  const handleMouseDown = useClickCallback(useCallback(() => {
    onSelect(seasonNumber);
  }, [onSelect, seasonNumber]));

  useEffect(() => {
    if (seasonNumber && isSelected) {
      gtmChangeItem({ selectedSeason: `${formatMessage({ id: 'common.seasonLabel' })} ${seasonNumber}` });
    }
  }, [formatMessage, gtmChangeItem, isSelected, seasonNumber]);

  return (
    <InteractiveElement
      tag="li"
      className={`dtv-html5-c-season-selector__season ${
        focused ? 'dtv-html5-c-season-selector__season--focused' : ''
      } ${
        isSelected ? 'dtv-html5-c-season-selector__season--selected' : ''
      } ${className}`}
      onMouseDown={handleMouseDown}
      onMouseEnter={onMouseEnter}
      role="menuitem"
    >
      <FormattedMessage id="common.seasonLabel" />
      &nbsp;
      {seasonNumber}
    </InteractiveElement>
  );
}

Season.defaultProps = {
  className: '',
  isSelected: false,
  focused: false,
  seasonNumber: 0,
  onSelect: undefined,
  onMouseEnter: undefined,
};

Season.propTypes = {
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  focused: PropTypes.bool,
  seasonNumber: PropTypes.number,
  onSelect: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

export default memo(withInteractiveFocusable()(memo(Season)));
